module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-aiapp.d96e96a7.png";